import JSZip from 'jszip'
import StreamSaver from 'streamsaver'
import { WritableStream, TransformStream } from 'web-streams-polyfill/ponyfill'

const state = {
  downloading: false,
  eventWriter: null
}

const resetState = function () {
  state.downloading = false
  state.eventWriter = null
}

// To test this method in dev env, run statistics page from localhost domain, i.e. http://localhost:3000/surveys/566199/stat
// This technology uses service workers, which are not allowed to run in insecure context
export function download(filename = '', files = [], onEveryFileCallback = null, onFinishCallback = null) {
  if (state.downloading) return
  state.downloading = true

  const zip = new JSZip()
  const downloadingFiles = files.map(function (fileData) {
    const request = new XMLHttpRequest()
    const promise = new Promise(function (resolve, reject) {
      request.responseType = 'blob'
      request.onload = function (_event) {
        resolve(request.response)
      }
      request.onerror = request.onabort = function (event) {
        reject(event)
      }
    })

    promise.startRequest = function () {
      request.open('GET', fileData.url, true)
      request.send()
    }

    zip.file(fileData.filename, promise, { binary: true })
    return promise
  })

  const startNextFileDownload = function () {
    const nextFile = downloadingFiles.shift()
    nextFile && nextFile.startRequest()
  }

  StreamSaver.WritableStream = WritableStream
  StreamSaver.TransformStream ||= TransformStream
  StreamSaver.mitm = '/javascripts/lib/StreamSaver/mitm.html'

  const fileStream = StreamSaver.createWriteStream(filename)
  const writer = fileStream.getWriter()
  state.eventWriter = writer

  const zipStream = zip.generateInternalStream({
    type: 'uint8array',
    compression: 'DEFLATE',
    compressionOptions: { level: 9 }
  })
  let previousFile
  zipStream
    .on('data', function (data, meta) {
      if (meta.currentFile && previousFile != meta.currentFile) {
        previousFile = meta.currentFile
        if (onEveryFileCallback && 'function' == typeof onEveryFileCallback) {
          onEveryFileCallback(meta.percent)
        }
        startNextFileDownload()
      }
      writer.write(data)
    })
    .on('end', function () {
      writer.close()
      if (onFinishCallback && 'function' == typeof onFinishCallback) {
        onFinishCallback()
      }
      resetState()
    })
    .on('error', function () {
      writer.abort()
      if (onFinishCallback && 'function' == typeof onFinishCallback) {
        onFinishCallback()
      }
      resetState()
    })
  startNextFileDownload()
  zipStream.resume()
}

window.addEventListener('unload', function () {
  state.eventWriter && state.eventWriter.abort()
})

window.addEventListener('beforeunload', function (event) {
  if (state.downloading) {
    event.returnValue = 'Download in progress. Are you sure you want to leave?'
  }
})
